module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Carolina Gold")]), _c('link', {
    attrs: {
      "href": "default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ser2"
  }, [_c('img', {
    staticClass: "maxwidth",
    attrs: {
      "alt": "One",
      "id": "p0009-d6e10",
      "src": "images/9781401687618__0120_002.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "p0009-03-1"
    }
  }, [_c('i', [_vm._v("There is in every true woman’s heart a spark of heavenly fire . . . which kindles up and beams and blazes in the dark hour of adversity.")])]), _vm._v(" "), _c('p', {
    staticClass: "txr2",
    attrs: {
      "id": "p0009-04-2"
    }
  }, [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASHINGTON")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RVING")])]), _vm._v(" "), _c('p', {
    staticClass: "ct",
    attrs: {
      "id": "p0009-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "page9"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#dt1",
      "id": "td1"
    }
  }, [_vm._v("One")])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    staticClass: "maxwidth",
    attrs: {
      "alt": "9781401687618_IN_0009_005.jpg",
      "id": "p0009-d6e28",
      "src": "images/9781401687618_IN_0009_005.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "txcc",
    attrs: {
      "id": "p0009-06-3"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HARLESTON")]), _vm._v(", S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUTH")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AROLINA")])]), _vm._v(" "), _c('p', {
    staticClass: "txcc1",
    attrs: {
      "id": "p0009-07-4"
    }
  }, [_c('i', [_vm._v("3 March 1868")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0009-08-5"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("I")]), _vm._v("n a quiet alcove off the hotel lobby, Charlotte Fraser perched on a worn horsehair chair, nursing a cup of lukewarm tea. A wind-driven freshet lashed the windows and roiled the bruise-colored sky, sending the pedestrians along Chalmers Street scurrying for shelter, jostling one another amid a sea of black umbrellas.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0009-09-8"
    }
  }, [_vm._v("She glanced at the clock mounted on the wall above the polished mahogany reception desk and pressed a hand to her midsection to quell her nerves. An hour remained before her appointment with her father’s lawyer. She had anticipated the meeting for weeks with equal measures of hope and dread, her happiness at the prospect of returning home to the river tempered by fear of what she would find waiting for her. In the war’s crushing aftermath, Fortune had cast her powerful eye upon all of the Lowcountry and passed on by.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0010-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("A black carriage shiny with rain executed a wide turn onto Meeting Street, the harness rattling as the conveyance halted beneath the porte cochere. The hotel door opened on a gust of wind and rain that guttered the lamps still burning against the afternoon gloom. A young man wearing a rain-splotched cape escorted his lady to the reception desk. He signed the register, then bent to his companion and whispered into her ear. An endearment perhaps. Or a secret.")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0010-01-1"
    }
  }, [_c('i', [_vm._v("“Every family has its secrets. And its regrets.”")]), _vm._v(" Charlotte set down her cup. Such strange words from Papa, who had been widely respected for his forthright manner. At the time, she’d had a strong feeling he was trying to tell her something important. Now the memory pinged inside her head like a knife against glass, prickling her skin. But perhaps such talk was merely the product of the laudanum clouding his brain during his final hours.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0010-01-3"
    }
  }, [_vm._v("For weeks following his funeral, Charlotte’s natural optimism lay trapped beneath a cloak of sorrow and she could feel little but the jagged edges of her grief. Now it had softened into something less painful. Acceptance, if not yet peace. And, as the indignities brought on by Reconstruction multiplied, gratitude that death had spared him yet another cruel irony. As former slaves wrestled with the implications of their freedom, their masters were mired in poverty that made their own futures just as uncertain.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0010-01-4"
    }
  }, [_vm._v("Despite her personal hardships, Charlotte was relieved that slavery had ended. At twenty-three she was too young and too inexperienced to assume responsibility for the welfare of so many others. During long nights when sleep eluded her and her problems crowded in, she sometimes doubted whether she could look after herself.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0010-01-5"
    }
  }, [_vm._v("When the clock chimed the three-quarter hour, she gathered her cloak, reticule, and umbrella and crossed the hotel lobby, the sound of her footfalls lost in the thick carpet.")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0011-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }), _c('a', {
    attrs: {
      "id": "page11"
    }
  })]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0011-P-1"
    }
  }, [_vm._v("The doorman, a stocky red-haired man of uncertain years, touched the brim of his hat. “Shall I find a carriage for you, Miss Fraser?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0011-01-1"
    }
  }, [_vm._v("“Thank you, but it isn’t necessary. I’m going to my lawyer’s office just down the street.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0011-01-2"
    }
  }, [_vm._v("He peered through the leaded-glass door. “Rain’s slacking off some, but the walk will feel like miles in this damp.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0011-01-3"
    }
  }, [_vm._v("She fished a coin from her bag. “Will you see that my trunks are delivered to the steamship office right away?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0011-01-4"
    }
  }, [_vm._v("“Certainly.” He pocketed the coin and held the door open for her. “Take care you don’t get a chill, miss.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0011-01-5"
    }
  }, [_vm._v("She threw her cloak over her stiff crepe mourning dress, stepped from beneath the hotel’s protective awning, and hurried down the street, rain thumping onto the stretched silk of her umbrella. Meeting Street hummed with carriages and drays, freight wagons and pedestrians headed in a dozen different directions. A buggy carrying a dark-skinned woman in a pink-plumed hat raced past, the wheels splashing dirty water onto the sidewalk. At the corner of Meeting and Broad, a Yankee officer stood chatting with two burly Negro men smoking cheroots. Charlotte picked her way along the slick cobblestones, past the remnants of burned-out buildings and the rubble of crumbled chimneys, feeling estranged from a city she knew like the back of her hand.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0011-01-6"
    }
  }, [_vm._v("As long as Papa was alive, she’d felt connected to every street and lane, every shop and church spire, every secret garden beckoning from the narrow shadowed alleys. Now everything had been upended. Nobody was where they were supposed to be and she was floating, adrift in a strange new world with no one to guide her.")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0011-01-7"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("She dodged a group of noisy boys emerging from a bookshop and gathered her skirts to avoid the dirty water splashing from the wheels of another passing carriage. Beneath the sheltering awning of a confectioner’s shop, two women watched her progress along ")]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("the street, their faces drawn into identical disapproving frowns. No doubt they thought it inappropriate for a young woman to walk on the street unescorted. She lifted her chin and met the older women’s gazes as she passed. If they knew the purpose of her visit to the lawyer, perhaps they’d be even further scandalized.")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0012-02-2"
    }
  }, [_vm._v("At the law office, she made her way up the steps and rang the bell.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0012-02-3"
    }
  }, [_vm._v("Mr. Crowley, a wizened man with a bulbous nose and a fringe of white hair, opened the door. “Miss Fraser. Right on time, I see. Do come in.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0012-02-5"
    }
  }, [_vm._v("She left her dripping umbrella in the brass stand in the anteroom, crossed the bare wooden floor, and took the seat he indicated. She folded her hands in her lap and waited while he settled himself and thumbed through the pile of documents littering his desk.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0012-02-7"
    }
  }, [_vm._v("Through the window she watched people and conveyances making their way along the street, ghostlike in the oyster-colored light of the waning afternoon. Down the block a lantern struggled against the gloom, casting a shining path on the rain-varnished cobblestones. Music from a partially opened window across the street filtered into the chilly office. Somebody practicing Chopin.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0012-02-8"
    }
  }, [_vm._v("She felt a prick of loss. According to their neighbors, the Federals had destroyed her piano on one of their wartime raids up the Waccamaw River. Probably everything else as well. Since the war’s end, the difficulties of travel and her father’s prolonged illness had prevented her from learning firsthand whether anything was left of Fairhaven Plantation.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0012-02-9"
    }
  }, [_vm._v("“Well, Mr. Crowley?” Charlotte consulted the ornate wall clock behind his desk. Captain Arthur’s steamship, "), _c('i', [_vm._v("Resolute")]), _vm._v(", traveled from Charleston to Georgetown only on Wednesdays and Saturdays. She meant to be aboard for tomorrow morning’s departure. If she could ever get an answer from the lawyer. “What about my father’s will?”")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0013-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("Without looking up, he raised one finger. Wait.")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0013-01-1"
    }
  }, [_vm._v("She tamped down her growing impatience. Waiting was about all she had been able to do since Papa’s death. That and worrying about how she would make her way in the world alone. Now that the war was lost and all the bondsmen were free, the rice trade that had provided her with a comfortable life was in danger of disappearing altogether. She was trained for nothing else.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0013-01-2"
    }
  }, [_vm._v("At last Mr. Crowley looked up, wire spectacles sliding down his nose. “The will has been entered into the record and duly recognized by the court.” He paged through a file, a frown creasing his forehead.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0013-01-3"
    }
  }, [_vm._v("“But?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0013-01-4"
    }
  }, [_vm._v("“I’d feel much better if your father had provided a copy of the grant to his barony.” He studied her over the top of his spectacles. “You’re certain he left no other papers behind?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0013-01-6"
    }
  }, [_vm._v("“No, none.” She felt a jolt of panic. “Does that pose a problem?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0013-01-7"
    }
  }, [_vm._v("“I hope not. There’s a new law on the books that provides for testimony regarding lost wills and deeds and such, but if you’ve never seen such a document, then you can hardly swear to its existence in court.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0013-01-8"
    }
  }, [_vm._v("“No, I suppose not.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0013-01-9"
    }
  }, [_vm._v("“Now that the Yankees have taken over, they can seize whatever they want in the name of Reconstruction.” He snorted. “Reconstruction, my eye. Theft is more like it.” He leaned forward, both palms pressed to his desk, and blew out a long breath. “Lacking proof of your father’s grant just makes it that much easier for them. Frankly I’m surprised he left no record behind. He seemed like a man who left little to chance. But I suppose we all have our shortcomings.”")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0013-01-12"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("Charlotte toyed with the clasp on her reticule. As a small child she had thought Papa the perfect embodiment of wisdom, intelligence, and prudence. A man without shortcomings. Only ")]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("occasionally had she glimpsed moments in which he seemed lost to time and place, standing apart and alone, an unreadable expression in his dark eyes. She still revered him as the finest man in Carolina, the only man in the world in whom she had absolute faith and confidence. Learning of such a grave oversight had come as a shock.")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-02-2"
    }
  }, [_vm._v("She met the lawyer’s calm gaze. “I don’t know why the Yankees would want my land now. According to everything I’ve heard, they just about destroyed every plantation on the Waccamaw—and the Pee Dee too.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-02-3"
    }
  }, [_vm._v("“Exactly. And sentiment aside, I can’t fathom what a lovely young woman such as yourself would want with such a ruin.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-02-4"
    }
  }, [_vm._v("“You’ve seen it, then? You’ve been to Fairhaven?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-02-5"
    }
  }, [_vm._v("“No, but all I’ve done since the war ended is work with the other rice planters, and the story is the same all over. I’m sure it’s no surprise to you that the Yankees and the freed slaves have stolen everything. Right down to the linens off the beds at Mrs. Allston’s place.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-02-7"
    }
  }, [_vm._v("“Yes, I heard about that. Papa said it was a blessing Governor Allston passed on before that sad day came. Chicora Wood meant so much to him.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-02-8"
    }
  }, [_vm._v("Mr. Crowley nodded. “I can’t imagine that your plantation has fared any better.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-02-9"
    }
  }, [_vm._v("She swallowed the knot in her throat. In his last months, Papa had spoken of little else but the bewildering loss that had stunned the entire Confederacy. Following General Lee’s surrender, everyone hoped the worst was over. No one realized that the future under Yankee occupation would become a tragedy all its own.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-02-10"
    }
  }, [_vm._v("Mr. Crowley leaned back in his chair, causing it to squeak. “While I was looking into your father’s will, Gabriel Titus over at the bank told me you’d applied for credit.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-02-12"
    }
  }, [_vm._v("“That’s right. To buy rice seeds. And whatever else I need to make Fairhaven profitable again.”")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-02-13"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("He shook his head. “Forgive me, Miss Fraser, but if an ")]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("experienced planter like Ben Allston can’t make a go of it, what makes you think you can?”")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-02-2"
    }
  }, [_vm._v("“Because I have no choice. The plantation and our summer cottage on Pawley’s Island are all I have left in the world.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-02-3"
    }
  }, [_vm._v("“You’d be better off to sell both of them and get yourself a nice little room here in town. Or better yet, find yourself a stable gentleman and settle down.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-02-4"
    }
  }, [_vm._v("Charlotte bit back a tart reply. More than a quarter million Southern men had been lost to the war, and many who survived had come home maimed in body or spirit or both, missing limbs and their fortunes. Just who in the world did Mr. Crowley think she could marry? “Mr. Titus told me that no one is interested in paying a fair price for Fairhaven or for Pelican Cottage. It would be quite impossible to sell even if I wanted to.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-02-5"
    }
  }, [_vm._v("“Did Titus lend you the money?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-02-6"
    }
  }, [_vm._v("“He agreed to a mortgage on Fairhaven. Out of respect for my father.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-02-7"
    }
  }, [_vm._v("“And what happens if you can’t repay the loan?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-02-8"
    }
  }, [_vm._v("“I have a year before it comes due. And I expect to earn a bit of money writing articles for the "), _c('i', [_vm._v("New York Enterprise")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-02-9"
    }
  }, [_vm._v("“My word.” He inclined his head, and his thick spectacles caught the light. “I had no idea you harbored journalistic ambitions. Or that you had the training for such an undertaking.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-02-11"
    }
  }, [_vm._v("“I’m not formally trained, but I can write a clear sentence and I know the Lowcountry as well as anyone.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-02-12"
    }
  }, [_vm._v("“Good gravy, woman. You think Yankees care about anything that goes on down here? They did all they could to destroy us.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-02-13"
    }
  }, [_vm._v("“The editor, Mr. Sawyer, seems to think his readers will be interested. I sent an inquiry last month and he has just replied, offering to pay ten dollars for each article. If I can write one a month, I’ll at least earn enough to keep the taxes paid. And if my rice crop comes in, I can repay the bank loan too.”")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0016-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }), _c('a', {
    attrs: {
      "id": "page16"
    }
  })]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0016-P-1"
    }
  }, [_vm._v("“If, if, if.” The lawyer sighed and glanced out the rain-smudged window. “I know how much that property means to you, but as your attorney and as your father’s friend, I still say the city life is more suitable for a young lady. Charleston is coming to life again. Folks are starting to rebuild. My wife tells me the St. Cecelia Society is already planning to hold two balls next year. But you surely know that.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0016-01-1"
    }
  }, [_vm._v("“I’ve had neither time nor inclination to pay attention to the social scene of late.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0016-01-2"
    }
  }, [_vm._v("“Still, going to a dance sounds more proper than wading around knee-deep in that foul-smelling muck, praying for rice to sprout.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0016-01-3"
    }
  }, [_vm._v("“I suppose.” As a young girl attending Madame Giraud’s boarding school, she’d loved the noise and gaiety of Charleston. Race Week, picnics at White Point, lectures and plays and dances provided welcome diversions from the monotony of lectures and recitations. Yet even then she had longed for quiet days in the country, trailing after Papa and learning everything he could teach her about the cultivation of rice. They loved all the same things—books, music, dogs and horses, and growing the special kind of rice called Carolina Gold. Even if she had money to burn, Charleston society held little appeal for her now. She wanted only to go home to Fairhaven, to pick up the pieces of her shattered world. To make it whole again.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0016-01-5"
    }
  }, [_vm._v("Mr. Crowley leaned forward, his piercing gaze holding hers. “You’re still a young woman. You ought to find a suitable husband.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0016-01-7"
    }
  }, [_vm._v("“Thank you for your advice.” She opened her reticule and slid a check across the desk. “This should cover your fee.”")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0016-01-8"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("“Now you’re offended, and I didn’t mean anything by it. I hate to see you get your hopes up only to be disappointed when you find out how bad things are up on the river.” He picked up the check and handed it back to her. “Your father was a good friend and I’m ")]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("mourning him too. I’m not about to take money from his only daughter at a time like this.”")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0017-02-2"
    }
  }, [_vm._v("“I . . . thank you. I’m sure it will be put to good use.” She rose. “I must go. I’m booked aboard the "), _c('i', [_vm._v("Resolute")]), _vm._v(". I should check to see that my things have been delivered to the pier.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0017-02-4"
    }
  }, [_vm._v("“I see. And what if the news here today had been different? What if I hadn’t been able to find your father’s will?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0017-02-5"
    }
  }, [_vm._v("“I’d have gone anyway, for one last ride around the fields. Lettice Hadley wrote last week that she and Mr. Hadley have returned to Alder Hill. She’s invited me to go riding with her as soon as I’m settled.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0017-02-7"
    }
  }, [_vm._v("“I’m glad of that. But the way I hear it, Charles Hadley is in a bad way and has been ever since the war. It isn’t likely he’ll be of much help.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0017-02-8"
    }
  }, [_vm._v("“Mrs. Hadley says the Magills are returning to Richmond Hill even though it’s in shambles too. She says the bank is holding the Magill sons responsible for an enormous debt their father incurred buying slaves, and they owe money to the Georgetown stores as well.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0017-02-9"
    }
  }, [_vm._v("“I wouldn’t know about that, but you’d best stay away from John Magill’s boys. The whole family has a bad reputation among the Negroes.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0017-02-10"
    }
  }, [_vm._v("“Yes. Papa often said he was the worst plantation owner in the entire Lowcountry. One cannot starve workers half to death. It’s not right, and it’s bad business as well.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0017-02-11"
    }
  }, [_vm._v("“True enough. It’s no wonder they hated him.” He paused to polish his spectacles. “From what I hear, there’s still some occasional unrest on the river. I’d hate for you to get caught up in it.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0017-02-12"
    }
  }, [_vm._v("“I imagine most of the Magills’ bondsmen are gone by now or working in Georgetown.”")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0017-02-13"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("“Just the same, you stay away from Richmond Hill.” He escorted her to the door and retrieved her umbrella. “For what it’s ")]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("worth, I hope you succeed in restoring Fairhaven. I enjoyed many happy visits there in the old days.”")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0018-02-2"
    }
  }, [_vm._v("“I intend to do my best.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0018-02-3"
    }
  }, [_vm._v("“Please call on me anytime you’re in Charleston. I want to know how you’re getting on.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0018-02-4"
    }
  }, [_vm._v("“You’re very kind. But I don’t expect I’ll make the trip too often. I’m not much of a sailor, and sixty miles is a very long way by land.” She drew on her gloves. “I intend to live simply, Mr. Crowley.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0018-02-7"
    }
  }, [_vm._v("“There’s nothing simple about growing rice.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0018-02-8"
    }
  }, [_vm._v("“That’s true. I meant that I’m sure I’ll find everything I need in Georgetown and will have little need to travel to Charleston.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0018-02-9"
    }
  }, [_vm._v("He held the door open for her. “It’s damp out there. I’d lend you my carriage for the ride to the pier. If I had one.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0018-02-10"
    }
  }, [_vm._v("Bitterness tinged his words. Charlotte nodded in sympathy. All across the South, as part of an attempt to cripple the Confederacy, the lawless Federals had stolen or killed as much livestock as possible. Lettice Hadley had been lucky indeed to have her horses spared.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0018-02-12"
    }
  }, [_vm._v("“Good-bye, Mr. Crowley. And thank you again.” With a final wave to the lawyer, she opened her umbrella and hurried toward the pier.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0018-02-13"
    }
  }, [_vm._v("At the steamship office she checked on her baggage, then peered out the office window at the red-and-white steamship rocking gently on the Cooper River. Beyond the breakwater, the Atlantic was a dull sheet of gray.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0018-02-14"
    }
  }, [_vm._v("Outside on the docks, draymen came and went with wagons bearing wooden cargo crates. Other passengers, Northerners mostly, judging from their speech, arrived and began boarding the steamship with bags, parcels, satchels, and umbrellas.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0018-02-15"
    }
  }, [_vm._v("“Miss?” The agent approached, his hat pulled low against the gray mist, a mug of steaming coffee in his hand. “You’d best go aboard now and get settled for the night. We’ll be putting out to sea at first light.”")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0019-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("She joined the line of passengers waiting to board. The gangplank screeched and swayed beneath her feet as she reached the ship and handed the ship’s master her ticket. He glanced at it and waved her aboard. “First room to starboard. It may be a bit noisy, but the ride will be smoother there if we hit bad weather.”")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0019-01-1"
    }
  }, [_vm._v("“Are you expecting a storm, Captain?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0019-01-2"
    }
  }, [_vm._v("He shrugged and offered the slightest of smiles. “It’s March in the Atlantic, miss. Anything can happen.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0019-01-3"
    }
  }, [_vm._v("Some years ago, the steamer "), _c('i', [_vm._v("Nina")]), _vm._v(" had left Georgetown bound for Nassau and was never heard from again. Lost in a storm, people said. Charlotte shivered and drew her cloak more tightly around her shoulders. The sooner she reached home, the better. She found her way to her quarters and went inside. Barely large enough for a narrow bed, a chair, and her trunks, the cabin at least had a small grimy window opened to let in the damp, chill air. She lit the lamp and set it on top of the larger trunk.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0019-01-5"
    }
  }, [_vm._v("Darkness fell and the noise abated as the last of the cargo was stowed and passengers settled in for the evening. The murmur of voices from those on deck and the smell of cooked meat drifted on the cooling air. Charlotte nibbled on a bit of chocolate, remembering a trip up the Waccamaw with Papa—had it been only ten years ago? It seemed a lifetime. She rummaged in her bags for her writing paper and a pencil.")]), _vm._v(" "), _c('p', {
    staticClass: "ext1",
    attrs: {
      "id": "p0019-02-7"
    }
  }, [_c('i', [_vm._v("Aboard the steamer Resolute. 3 March 1868.")])])]), _c('p', {
    staticClass: "ext2",
    attrs: {
      "id": "p0019-02-8"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('i', [_vm._v("The spring I turned thirteen, Papa arranged a trip from our plantation to Charleston, sixty miles to the south, to celebrate my birthday. It was our first such outing since my mother died the year before, the yellow fever wringing the last breath from her slender body. Papa and I were left to mourn—and to assign a measure of blame, for Mama knew that to remain on the plantation in the summer posed the risk of fever. But  ")])]), _c('i', [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("Minty, one of her favorite house servants, was in the throes of a difficult birthing, and the doctor who customarily tended to such matters was nowhere to be found.")])])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "ext2",
    attrs: {
      "id": "p0020-01-1"
    }
  }, [_c('i', [_vm._v("Mama insisted on staying behind until the babe was safely delivered. Though she never expressed an opinion contrary to Papa’s, she saw herself as the savior of the more than three hundred slave women who lived at Fairhaven and her sacred duty that of preparing them for their freedom which surely would one day come. That she lost her own freedom, her very life, in pursuit of that ideal was not lost on Papa and me. But we carried on as best we could. There was rice to plant and to harvest and, when the time came, a birthday to mark.")])]), _vm._v(" "), _c('p', {
    staticClass: "ext2",
    attrs: {
      "id": "p0020-01-2"
    }
  }, [_c('i', [_vm._v("And so, on a breezy Friday in March, Papa and I found ourselves steaming southward on the Island Queen. Upon disembarking we enjoyed dinner at the Mills House, a new production at the theater, and a shopping expedition along Meeting Street. In a milliner’s window I spied a cunning little hat bedecked with blue ribbons and prevailed upon Papa to buy it for me.")])]), _vm._v(" "), _c('p', {
    staticClass: "ext2",
    attrs: {
      "id": "p0020-01-3"
    }
  }, [_c('i', [_vm._v("“You are too young yet for flirting,” he said when the milliner told me the ribbons trailing down my back were called flirtation ribbons.")])]), _vm._v(" "), _c('p', {
    staticClass: "ext2",
    attrs: {
      "id": "p0020-01-4"
    }
  }, [_c('i', [_vm._v("I quite agreed with him then, for I couldn’t imagine finding any man who would be as wonderful and handsome as Papa.")])])]), _c('p', {
    staticClass: "ext2",
    attrs: {
      "id": "p0020-01-5"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('i', [_vm._v("I wore my new hat on our trip home, standing with my father on the sooty deck as the steamer made its way into Winyah Bay and nudged the pier at Georgetown to discharge passengers and cargo. Since we had an hour’s wait before continuing our journey up the Waccamaw")])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('i', [_vm._v("River, Papa and I disembarked and crossed a rickety dock stacked high with casks of turpentine and resin and with lumber bound for Northern markets. Slaves hurried about like a colony of ants, moving cargo, directing drays and rigs. Steam whistles shrieked, drowning out the voices of the vendors stationed near the steamship office.")])])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "ext2",
    attrs: {
      "id": "p0021-01-2"
    }
  }, [_c('i', [_vm._v("Arm in arm, Papa and I strolled past the courthouse and the bank, the newspaper office and the busy slave market. We bought fried pies from a pastry shop on the waterfront. Papa wiped a smudge of sugar from my nose and told me I was a lucky girl indeed to be living in the very heart of the Lowcountry.")])]), _vm._v(" "), _c('p', {
    staticClass: "ext2",
    attrs: {
      "id": "p0021-01-3"
    }
  }, [_c('i', [_vm._v("Now everything has changed. I wonder whether I shall ever again feel so lucky.")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0021-02-5"
    }
  }, [_vm._v("Charlotte set aside her pencil. Perhaps she’d disembark in Georgetown and post her article for Mr. Sawyer’s newspaper from there. The sooner she could start earning money, the better.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0021-02-6"
    }
  }, [_vm._v("Standing on tiptoe, she peered out the small window. The ship’s master strolled the deck smoking his pipe, watching a scrim of high clouds forming on the horizon. In the next cabin two women laughed. The ship’s bell tolled the hour. Charlotte stepped out of her dress and draped it over the edge of the narrow bed. There was no basin for washing up, only a small pitcher of lukewarm water and a single tin cup. She unpinned her hair, dabbed at her face with her handkerchief, and crawled into the narrow bunk.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0021-02-7"
    }
  }, [_vm._v("Despite her trepidation at what she would find upriver, she was filled with something like hope. Tomorrow—for better or worse—she would be home.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ecba1744","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter4.vue
// module id = 81
// module chunks = 0